import script from "./AdminReview.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminReview.vue?vue&type=script&setup=true&lang=js"

import "./AdminReview.vue?vue&type=style&index=0&id=fc5fcc0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc5fcc0e"]])

export default __exports__